import { type GameState } from 'src/types'

const newsave: GameState = {
  switches: {
    is_resting: false,
    is_levelling_up: false
  },
  counters: {
    player_victories: 0,
    player_defeats: 0,
    player_deaths: 0,
    player_cash: 0,
    day: 0,
    cigs: 0,
    karma: 0
  },
  variables: {
    event_id: 'rebirth',
    enemy_id: ''
  }
}

export {
  newsave
}
